<template>
	<div v-if="questions.length !== 0" >
		<div class="qcm-container">
			<div class="img-container">
				<img src="/img/student-place/qcm-bg.jpg" alt="">
				<div class="text-container">
					<p class="title">Question Flash</p>
					<p>{{ name }}</p>
				</div>
			</div>
			<!-- <div class="exo" ref="imgContainer"></div> -->
			<!-- <div class="imgContainer">
				<img src="/img/student-place/qcm-bg.jpg" alt="">
			</div>-->
			<div class="action-container">
				<router-link
					:to="{
						name: 'StudentPlaceDisplayActivity',
						params: { id: id},
					}"
				>
					<span>Voir</span>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import Config from '../../config'

export default {
	props: {
		id: Number,
		activities: Array,
		name: String,
		isCorrectionShown: Boolean
	},
	data() {
		return {
			added: false,
			readyToDisplay: false,
			questions: [],
			isPopUpVisible: false,
			chapters: [],
			showPopUpSlide: false,
			image1: null,
			isImgSet: false,
		}
	},
	methods: {
		getChapters() {
			let chapter = []
			let chapterName = []
			this.questions.forEach(element => {
				if (!chapter.includes(element.chapter)) {
					chapter.push(element.chapter)
				}
			})
			chapter.forEach((element, index) => {
				if (element) {
					axios.get(`${Config.backend_url}/api/v1/chapters/${element}/`)
						.then(response => {
							chapterName.push(response.data.name)
							if (index == chapter.length - 1) {
								this.chapters = chapterName
							}
						})
						.catch(error => console.error(error))
				}
			})
			return chapterName
		},
		popUp() {
			this.isPopUpVisible = !this.isPopUpVisible
		},
		getQuestions() {
			this.activities.forEach(element => {
				axios.get(`${Config.backend_url}/api/v1/questions-instances/${element.id}/`, { method: 'GET' })
					.then(response => {
						this.questions.push(response.data)
						// if (!this.isImgSet && response.data.image_url_1) {
						// 	this.image1 = response.data.image_url_1
						// 	this.getImage()
						// 	this.isImgSet = true
						// }
						this.getChapters()
					})
					.catch(error => console.error(error))
			}
			)
		},
		color(e) {
			let color
			switch (e) {
				case 'Facile':
					color = 'green'
					break
				case 'Moyen':
					color = 'orange'
					break
				case 'Difficile':
					color = 'red'
					break

				default:
					break
			}
			return color
		},

		add() {
			this.added = !this.added
			this.$emit('addQuestion')
		},
		reRender() {
			if (window.MathJax.typesetPromise) {
				window.MathJax.typesetPromise();
			}
		},
	},
	created() {
		this.reRender()
		this.getQuestions()
	},
	mounted() {

		this.reRender()
		setTimeout(() => {
			this.readyToDisplay = true
		}, 1000)

	},
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/student-place/qcm-container.scss';

</style>
